define("shared/validations/currency", ["exports", "@ember/utils", "shared/utils/fp/result"], function (_exports, _utils, _result) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.parseCurrencyValue = _exports.getCurrencyValue = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/utils",0,"shared/utils/fp/result"eaimeta@70e063a35619d71f
  const getCurrencyValue = rawCurrencyValue => {
    const parsed = parseCurrencyValue(rawCurrencyValue);
    return (0, _result.isOk)(parsed) ? parsed.value : 0;
  };

  /**
   * Parse currency value, handling "$100", "1,234.56", etc.
   * Returns Result with error reason or parsed number
   */
  _exports.getCurrencyValue = getCurrencyValue;
  const parseCurrencyValue = value => {
    if (!(0, _utils.isPresent)(value) || value === '') {
      return (0, _result.error)('empty');
    }
    const stringValue = String(value).trim();
    if (stringValue === '') {
      return (0, _result.error)('empty');
    }

    // Remove optional leading $ and validate comma format before stripping
    const withoutDollar = stringValue.replace(/^\$/, '');

    // Validate proper comma placement: either no commas, or commas every 3 digits from the right
    // Valid: "1234", "1,234", "1,234,567", "1234.56", "1,234.56"
    // Invalid: "1,,234", "12,34", "1,2345"
    const validFormat = /^-?(\d{1,3}(,\d{3})*|\d+)(\.\d+)?$/;
    if (!validFormat.test(withoutDollar)) {
      return (0, _result.error)('invalid_format');
    }
    const cleaned = withoutDollar.replace(/,/g, '');
    if (!/^-?\d+\.?\d*$/.test(cleaned)) {
      return (0, _result.error)('invalid_format');
    }
    const parsed = parseFloat(cleaned);
    return isNaN(parsed) ? (0, _result.error)('invalid_format') : (0, _result.ok)(parsed);
  };
  _exports.parseCurrencyValue = parseCurrencyValue;
});